import { useAuth0 } from '@auth0/auth0-react';
import { ga } from '@/lib/analytics';
import {
  clearPostLoginRedirect,
  storePostLoginRedirect,
} from '@/lib/postLoginRedirect';

export const useAppLogout = () => {
  const { logout } = useAuth0();

  // `postLoginPath` is for "Switch account": `returnTo` stays /login, the
  // only URL registered in the tenant's Allowed Logout URLs, and the stored
  // path is what carries the user on to where they actually wanted to be.
  // Callers used as an onClick handler directly must wrap the call, or the
  // click event arrives here as the path.
  return (postLoginPath?: string) => {
    ga.clearUserId();
    if (postLoginPath) {
      storePostLoginRedirect(postLoginPath);
    } else {
      // A plain logout abandons any target stored earlier, so the next
      // login lands where it normally would.
      clearPostLoginRedirect();
    }
    logout({
      logoutParams: {
        returnTo: window.location.origin + '/login',
      },
    });
  };
};
